const CommonPermissions = {
  // VIEW
  LIST_USERS: 'users_list__view',
  LIST_PROCESSING_NODES: 'apns_list__view',
  RETRIEVE_COMPANIES: 'companies_detail__retrieve',
  LIST_COMPANIES: 'companies_list__view',
  RETRIEVE_RESELLERS: 'resellers_detail__view',
  LIST_RESELLERS: 'resellers_list__view',
  RETRIEVE_USERS: 'users_detail__view',
  VIEW_SETTINGS: 'common_settings_page_read',
  VIEW_COMPANY_SETTINGS: 'common_company_settings_page_read',
  VIEW_RESELLER_SETTINGS: 'common_reseller_settings_page_read',

  //   WRITE
  CREATE_COMPANIES: 'companies__create',
  CREATE_USERS: 'users__create',
  CREATE_RESELLERS: 'resellers__create',
  CREATE_PROCESSING_NODES: 'apns__create',
  WRITE_CONTROL_PANEL_PAGE: 'operations_page_write',

  // UPDATE
  UPDATE_COMPANIES: 'companies__update',
  UPDATE_USERS: 'users__update',
  UPDATE_RESELLERS: 'resellers__update',
  UPDATE_PROCESSING_NODES: 'apns__update',
  UPDATE_OWN_USER_DETAILS: 'users_current__update',

  //   DELETE
  DELETE_PROCESSING_NODES: 'apns__delete',

  // Action
  KILL_APN: 'apns__kill',
};

export default CommonPermissions;
